import isNil from 'lodash/isNil';

export const FILTER_KEYS = {
  NAME: 'name',
};

export const DEFAULT_FILTERS = {
  [FILTER_KEYS.NAME]: '',
};

// only handling string value filters currently
export function hasFilters(filters = {}) {
  if (isNil(filters) || typeof filters !== 'object') {
    return false;
  }

  return Object.keys(filters).some(filter => Boolean(filters[filter]));
}

/**
 * All lua modules names are lowercase in the backend and only allow for '.' special char.
 */
export function filterTransformLibModulesByName({ transformLibModules, searchTerm = '' } = {}) {
  // input checks
  if (!Array.isArray(transformLibModules)) {
    return [];
  }

  if (isNil(searchTerm) || typeof searchTerm !== 'string') {
    return transformLibModules;
  }

  const lowerCaseSearchTerm = searchTerm.toLowerCase().trim();

  if (!lowerCaseSearchTerm) {
    return transformLibModules;
  }
  // end input checks

  // not stripping '.', assuming if user is including a '.' they want to match it
  return transformLibModules.filter(transformModule => {
    const moduleName = transformModule.name.toLowerCase().trim();
    return moduleName.includes(lowerCaseSearchTerm);
  });
}
